import { makeStyles } from 'tss-react/mui';

export const useOrderProductGridContentStyles = makeStyles()(() => ({
  highlightSugestion: {
    '& ::placeholder': {
      opacity: 1,
    },
  },
}));
